import ActiveRecordError from './ActiveRecordError.js';
/**
 */
export class NotFoundError extends ActiveRecordError {
}
export default NotFoundError;
